import { Post } from '@/types/posts';

export const mockPosts: Post[] = [
  {
    id: '1',
    author: {
      id: '101',
      username: 'kiki',
      display_name: 'Kiki',
      avatar_url: "/avatars/kiki.svg",
      is_staff: false,
      is_verified: false,
      location: 'Washington, DC'
    },
    community: null,
    type: 'regular',
    category: 'help',
    title: null,
    content: 'Mình cần mượn bàn ủi đến chiều nay, ai giúp được không ạ?\nThời gian: Từ 10h30 đến 18h\nĐịa chỉ: Hà Nội',
    location: 'Hà Nội',
    status: 'active',
    media: [{
      type: 'image',
      url: '/avatars/banui.png'
    }],
    tags: ['help', 'borrow'],
    is_featured: false,
    is_edited: false,
    edited_at: null,
    view_count: 42,
    comments_count: 0,
    reactions_count: 0,
    participants_count: 0,
    is_liked: false,
    latest_comments: [],
    media_preview: [],
    createdAt: '2023-08-15T09:30:00Z',
    updated_at: '2023-08-15T09:30:00Z',
    start_date: null,
    end_date: null,
    max_participants: null,
    helper: null,
    due_date: null
  },
  {
    id: '2',
    author: {
      id: '102',
      username: 'marnie',
      display_name: 'Marnie',
      avatar_url: '/avatars/marnie.svg',
      is_staff: false,
      is_verified: false,
      location: 'Washington, DC'
    },
    community: null,
    type: 'regular',
    category: 'regular',
    title: null,
    content: 'Mình đọn tủ có vài bộ đồ bé gái, còn sạch đẹp, ai cần cứ nhắn mình nhé.\nTình trạng: Sạch - còn tốt\nLấy tại nhà / hẹn điểm gặn',
    location: 'Washington, DC',
    status: 'active',
    media: [{
      type: 'image',
      url: '/avatars/banui.png'
    }],
    tags: ['give', 'clothes'],
    is_featured: false,
    is_edited: false,
    edited_at: null,
    view_count: 87,
    comments_count: 15,
    reactions_count: 20,
    participants_count: 3,
    is_liked: false,
    latest_comments: [],
    media_preview: [],
    createdAt: '2023-08-14T14:20:00Z',
    updated_at: '2023-08-14T14:20:00Z',
    start_date: null,
    end_date: null,
    max_participants: null,
    helper: null,
    due_date: null
  },
  {
    id: '3',
    author: {
      id: '102',
      username: 'marnie',
      display_name: 'Marnie',
      avatar_url: '/avatars/kiki.svg',
      is_staff: false,
      is_verified: false,
      location: 'Washington, DC'
    },
    community: null,
    type: 'regular',
    category: 'alert',
    title: null,
    content: 'Mình đi vắng thứ 7 & CN, cần ai gần khu E tưới cây giúp với. Có phân quà nhỏ cảm ơn ❤️',
    location: 'Washington, DC',
    status: 'active',
    media: [],
    tags: ['help', 'plants'],
    is_featured: false,
    is_edited: false,
    edited_at: null,
    view_count: 65,
    comments_count: 15,
    reactions_count: 20,
    participants_count: 2,
    is_liked: false,
    latest_comments: [],
    media_preview: [],
    createdAt: '2023-08-13T16:45:00Z',
    updated_at: '2023-08-13T16:45:00Z',
    start_date: null,
    end_date: null,
    max_participants: null,
    helper: null,
    due_date: null
  }
];
